import React, { useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useTheme } from "styled-components";
import ClickAwayListener from "@mui/material/ClickAwayListener";
import { ErrorOutline } from "@mui/icons-material";
import { BreadPath, PortfolioPlaceHolder } from "../../components";
import {
  LocaleConfigsSelector,
  PortfolioEditor,
  QuantumBanner,
  SearchAsset,
} from "../../components/shared";
import { useCurrentPortfolio, useShowShareError } from "../../store";
import {
  SGridColumnLeft,
  SGridColumnRight,
  SGridContainer,
  SGridLocaleFloatingMenu,
  SGridOuterContainer,
  SGridQuantumBanner,
  SMessage,
  SSearchArea,
  STitle,
  SPopover,
  SPopoverMessageContainer,
  SPopoverMessage,
  SClosePopoverButton,
  SClosePopoverIcon,
} from "./styles";

export const PortfolioComposer: React.FC = () => {
  const { t } = useTranslation();
  const [secondaryMessage, setSecondaryMessage] = useState(false);
  const { selectedPortfolio } = useCurrentPortfolio();
  const theme = useTheme();
  const { shareError, setShareError } = useShowShareError();
  const gridRef = useRef<HTMLDivElement>(null);

  const handleClosePopover = (): void => {
    setShareError(false);
  };

  return (
    <SGridOuterContainer>
      <SGridContainer
        sx={{
          position: "relative",
          zIndex: 1,
        }}
      >
        <SGridColumnLeft sx={{ position: "relative" }} ref={gridRef}>
          <SPopover
            open={shareError}
            anchorEl={gridRef.current}
            anchorOrigin={{
              vertical: "top",
              horizontal: "right",
            }}
          >
            <ClickAwayListener onClickAway={handleClosePopover}>
              <SPopoverMessageContainer>
                <SClosePopoverButton onClick={handleClosePopover}>
                  <SClosePopoverIcon />
                </SClosePopoverButton>
                <SPopoverMessage>
                  <SPopoverMessage>
                    <ErrorOutline />
                    {t("share.failedLoadingSharedLink")}
                  </SPopoverMessage>
                </SPopoverMessage>
              </SPopoverMessageContainer>
            </ClickAwayListener>
          </SPopover>
          <BreadPath path="root" />
          <STitle>{t("composerSelecAssetTitle")}</STitle>
          <SMessage>
            {secondaryMessage
              ? t("composerSelectAssetMessage.secondary")
              : t("composerSelectAssetMessage.primary")}
          </SMessage>
          <SSearchArea>
            <SearchAsset
              setSecondaryMessage={setSecondaryMessage}
              secondaryMessage={secondaryMessage}
            />
          </SSearchArea>
          {theme.localeSettings.showInsideLeftColumn && (
            <SGridLocaleFloatingMenu>
              <LocaleConfigsSelector />
            </SGridLocaleFloatingMenu>
          )}
        </SGridColumnLeft>
        <SGridColumnRight>
          {selectedPortfolio === null ? (
            <PortfolioPlaceHolder />
          ) : (
            <PortfolioEditor />
          )}
        </SGridColumnRight>
      </SGridContainer>
      <SGridQuantumBanner>
        <QuantumBanner />
      </SGridQuantumBanner>
    </SGridOuterContainer>
  );
};
